import React from "react";
import { Button } from "./styles";

const ButtonComponent = (props) => {
  return (
    <Button
      disabled={props.disabled || props.loading}
      onClick={props.clickHandler || null}
      type={props.type || "button"}
      theme={props.theme}
    >
      {props.label}
    </Button>
  );
};

export default ButtonComponent;
